// Static product catalogue — used as instant fallback so products NEVER disappear
// even if the backend API is briefly unreachable (restart, network blip, etc.).
// Kept intentionally in sync with /app/backend/server.py PRODUCTS.

const RAW_STATIC_PRODUCTS = [
  {
    id: "coussin-massant-chauffant",
    slug: "coussin-massant-chauffant",
    shipping_origin: "europe",
    base_price: 79.0,
    currency: "EUR",
    badge: { fr: "Best-seller", en: "Best-seller" },
    name: {
      fr: "Coussin Massant Chauffant",
      en: "Heated Massage Cushion",
    },
    tagline: {
      fr: "Le rituel anti-tensions",
      en: "The anti-tension ritual",
    },
    urgency: {
      fr: "🇫🇷 Stock en Europe — Livré en France en 3 à 7 jours ouvrés",
      en: "🇪🇺 In stock in Europe — Delivered to France in 3 to 7 business days",
    },
    seo_title: {
      fr: "Coussin Massant Chauffant | Livraison Rapide | myFLOVEA",
      en: "Heated Massage Cushion | Fast Delivery | myFLOVEA",
    },
    seo_description: {
      fr: "Coussin Massant Chauffant myFLOVEA : massage relaxant et chaleur enveloppante pour soulager le dos. Stock en Europe, livré en France en 3 à 7 jours. Satisfait ou remboursé 30 jours.",
      en: "myFLOVEA Heated Massage Cushion: relaxing massage and enveloping heat to relieve back pain. Stock in Europe, delivered to France in 3-7 days. 30-day money back.",
    },
    stock_delivery_badge: {
      fr: "📦 Stock en Europe — Livré en France en 3 à 7 jours",
      en: "📦 Stock in Europe — Delivered to France in 3–7 days",
    },
    faq: {
      fr: [
        { q: "Combien de temps pour être livré en France ?",
          a: "Le Coussin Massant Chauffant est stocké en Europe et livré en 3 à 7 jours ouvrés en France." },
        { q: "Le coussin chauffe-t-il vraiment ?",
          a: "Oui, il dispose de plusieurs niveaux de chaleur réglables via la télécommande, pour une chaleur enveloppante et apaisante." },
        { q: "Puis-je l'utiliser sur n'importe quelle chaise ?",
          a: "Oui, il s'adapte à la plupart des chaises de bureau et fauteuils grâce à ses sangles de fixation." },
        { q: "Que faire si le produit ne me convient pas ?",
          a: "Nous offrons une garantie satisfait ou remboursé de 30 jours, avec bordereau de retour prépayé." },
        { q: "Quelle est la différence entre Tissu et Velours ?",
          a: "Le Tissu Standard est respirant et facile à entretenir — parfait pour une utilisation quotidienne au bureau ou en voiture. Le Velours Premium offre un toucher plus doux et luxueux — idéal pour ceux qui veulent la meilleure expérience possible." },
        { q: "Est-il silencieux ?",
          a: "Oui, moteur discret conçu pour une utilisation au bureau sans déranger." },
        { q: "Puis-je l'utiliser tous les jours ?",
          a: "Oui, conçu pour un usage quotidien. Sessions recommandées de 15 à 20 minutes pour un résultat optimal." },
      ],
      en: [
        { q: "How long is delivery to France?",
          a: "The Heated Massage Cushion is stocked in Europe and delivered to France in 3 to 7 business days." },
        { q: "Does the cushion really heat up?",
          a: "Yes, it features several adjustable heat levels via the remote control, for enveloping and soothing warmth." },
        { q: "Can I use it on any chair?",
          a: "Yes, it adapts to most office chairs and armchairs thanks to its adjustable fixing straps." },
        { q: "What if the product doesn't suit me?",
          a: "We offer a 30-day money-back guarantee with a prepaid return label." },
        { q: "What's the difference between Fabric and Velvet?",
          a: "Standard Fabric is breathable and easy to maintain — perfect for daily office or car use. Premium Velvet offers a softer, more luxurious feel — ideal for those who want the best possible experience." },
        { q: "Is it silent?",
          a: "Yes, discreet motor designed for office use without disturbing." },
        { q: "Can I use it every day?",
          a: "Yes, designed for daily use. Recommended sessions of 15 to 20 minutes for optimal results." },
      ],
    },
    decision_aid: {
      fr: "💡 Vous hésitez ? Le Velours est choisi par 7 clients sur 10.",
      en: "💡 Hesitating? Velvet is chosen by 7 in 10 customers.",
    },
    certifications: {
      fr: "✅ Certifié CE, ROHS et FCC — Conforme aux normes européennes de sécurité",
      en: "✅ CE, ROHS and FCC certified — Compliant with European safety standards",
    },
    power_supply: {
      fr: "Prise allume-cigare pour la voiture et adaptateur secteur pour le bureau et la maison — les deux inclus dans la boîte.",
      en: "Car-lighter plug and mains adapter — both included in the box.",
    },
    reviews: [
      {
        name: "Cédric T.",
        rating: 5,
        verified: true,
        text: {
          fr: "Reçu rapidement, qualité vraiment impressionnante. Mon dos me remercie après mes longues journées de télétravail.",
          en: "Fast delivery, impressive quality. My back thanks me after long work-from-home days.",
        },
        image: "/photos/coussin/coussin-review-1.webp",
      },
      {
        name: "Mathias S.",
        rating: 5,
        verified: true,
        text: {
          fr: "Je l'utilise tous les jours au bureau et en voiture. Franchement bluffant, je ne m'en passe plus.",
          en: "I use it daily at the office and in my car. Honestly stunning — can't live without it.",
        },
        image: "/photos/coussin/coussin-hero.webp",
      },
    ],
    cross_sell_slug: "sphere-duo",
    headline: {
      fr: "Transforme n'importe quel siège en fauteuil de récupération.",
      en: "Turn any seat into a true recovery chair.",
    },
    short: {
      fr: "9 modes de massage, chaleur apaisante jusqu'à 45°C. Bureau, voiture, salon — expédié depuis l'Allemagne en 3 à 7 jours.",
      en: "9 massage modes, soothing heat up to 45°C. Office, car, sofa — ships from Germany in 3–7 days.",
    },
    description: {
      fr: "Tu passes des heures assis. Au bureau, en voiture, chez toi. Ton dos le ressent, tes épaules aussi. Pas besoin d'attendre le weekend pour décompresser.\n\nLe Coussin Massant Chauffant myFLOVEA transforme n'importe quel siège en vrai moment de récupération — sans bouger, sans rendez-vous, sans attendre. En moins d'une minute, tu retrouves ta parenthèse détente, où que tu sois.\n\n9 modes de massage ciblés sur les épaules, le dos et les lombaires. Chaleur apaisante intégrée pour relâcher les tensions en profondeur. 3 niveaux d'intensité pour adapter le massage à ton humeur — doux après une longue journée, intense après le sport.\n\nUn vrai coussin de massage électrique, pensé pour un usage quotidien : ce coussin de massage électrique combine vibrations shiatsu et thermothérapie douce (jusqu'à 45°C) pour reproduire l'effet d'un massage manuel professionnel, chez toi. Chaque zone — nuque, milieu du dos, lombaires, cuisses — peut être activée séparément grâce à la télécommande filaire. Aucun montage, aucune application à installer : tu poses le coussin sur ton siège, tu branches, tu appuies.\n\nLe massage dos chauffant qui te suit partout : grâce à ses sangles élastiques universelles, le Coussin Massant Chauffant s'adapte à ton fauteuil de bureau, à ton siège auto, ou au canapé du salon. Prise USB et prise allume-cigare 12V incluses — tu l'emmènes en week-end, tu le laisses au bureau, ou tu le montes dans la voiture. Le massage dos chauffant est là où tu en as besoin, quand tu en as besoin.\n\nLivraison rapide depuis notre stock européen : notre stock est basé en Europe, ce qui te garantit une livraison rapide en France en 3 à 7 jours ouvrés, suivie et gratuite. Numéro de suivi envoyé automatiquement par email dès l'expédition, tu sais à tout moment où en est ton colis.\n\nCertifié CE, ROHS et FCC — conforme aux normes européennes de sécurité. Garantie 2 ans + satisfait ou remboursé 30 jours avec bordereau de retour prépayé. Service client francophone, réponse sous 24h ouvrées.",
      en: "You spend hours sitting. At the office, in the car, at home. Your back feels it, your shoulders too. No need to wait for the weekend to unwind.\n\nThe myFLOVEA Heated Massage Cushion turns any seat into a real recovery moment — no movement, no appointment, no waiting.\n\n9 massage modes targeted on shoulders, back and lower back. Integrated soothing heat to release tension deep down. 3 intensity levels to match your mood — gentle after a long day, intense after sport.\n\nA true electric massage cushion, designed for daily use: this electric massage cushion combines shiatsu vibrations with gentle thermotherapy (up to 45°C) to recreate the effect of a professional manual massage, at home. Each zone — neck, mid-back, lower back, thighs — can be activated separately via the wired remote. No setup, no app to install: place the cushion on your seat, plug it in, press.\n\nThe heated back massage that follows you everywhere: thanks to its universal elastic straps, the Heated Massage Cushion adapts to your office chair, car seat, or living-room sofa. USB and 12V lighter plug included — take it on the weekend, leave it at the office, or set it up in the car. Heated back massage wherever you need it, whenever you need it.\n\nFast delivery from our European stock: our stock is based in Europe, guaranteeing fast delivery to France in 3 to 7 business days, tracked and free. Tracking number sent automatically by email upon dispatch.\n\nCE, ROHS and FCC certified. 2-year warranty + 30-day money back with prepaid return label. French-speaking customer service, reply within 24 business hours.",
    },
    variants: [
      {
        id: "tissu-standard",
        price: 79.0,
        name: { fr: "Tissu Standard", en: "Standard Fabric" },
        desc: { fr: "Résistant et facile d'entretien — idéal pour une utilisation quotidienne intensive", en: "Durable and easy to clean — perfect for heavy daily use" },
        badge: null,
        in_stock: true,
        images: [
          "/photos/coussin/coussin-hero.webp",
        ],
      },
      {
        id: "velours-premium",
        price: 89.0,
        name: { fr: "Velours Premium", en: "Premium Velvet" },
        desc: { fr: "Ultra-doux, soyeux au toucher — pour une expérience encore plus cocooning et luxueuse", en: "Ultra-soft and silky to the touch — for an even more cocooning, luxurious experience" },
        badge: { fr: "✨ La plus choisie", en: "✨ Most chosen" },
        in_stock: true,
        images: [
          "/photos/coussin/coussin-velours.webp",
        ],
      },
    ],
    common_images: [
      "/photos/coussin/coussin-voiture.webp",
      "/photos/coussin/coussin-siege-velour.webp",
      "/photos/coussin/coussin-telecommande.webp",
      "/photos/coussin/coussin-review-1.webp",
    ],
    key_points: {
      fr: [
        "🎯 9 modes + chaleur — une récupération complète en quelques minutes",
        "🚚 Expédié depuis l'Allemagne 🇩🇪 — livré en 3 à 7 jours ouvrés par DHL",
        "🔒 Satisfait ou remboursé 30 jours — sans questions",
      ],
      en: [
        "🎯 9 modes + heat — full recovery in minutes",
        "🚚 Ships from Germany 🇩🇪 — delivered in 3–7 business days via DHL",
        "🔒 30-day money back — no questions asked",
      ],
    },
    shipping_info: {
      fr: "Expédié depuis notre entrepôt en Allemagne 🇩🇪 — Livré en 3 à 7 jours ouvrés par DHL. Numéro de suivi envoyé par email.",
      en: "Shipped from our warehouse in Germany 🇩🇪 — Delivered in 3–7 business days via DHL. Tracking number sent by email.",
    },
    fast_ship_badge: {
      fr: "Livraison rapide — Expédié depuis l'Europe (Allemagne)",
      en: "Fast delivery — Ships from Europe (Germany)",
    },
    stock_badge: {
      fr: "Stock disponible en Europe",
      en: "In stock in Europe",
    },
    delivery_time_badge: {
      fr: "Livré en 3 à 7 jours ouvrés",
      en: "Delivered in 3–7 business days",
    },
    faq: {
      fr: [
        { q: "Quelle est la différence entre Tissu et Velours ?",
          a: "Le Tissu Standard est résistant et facile à entretenir — parfait pour une utilisation quotidienne intensive. Le Velours Premium est ultra-doux et soyeux — pour une expérience encore plus cocooning et luxueuse." },
        { q: "Fonctionne-t-il sur tous les sièges ?",
          a: "Oui, sangles ajustables universelles — voiture, bureau, salon, canapé." },
        { q: "Est-il silencieux ?",
          a: "Oui, moteur discret conçu pour une utilisation au bureau sans déranger." },
        { q: "Comment il se branche ?",
          a: "Prise allume-cigare pour la voiture et adaptateur secteur pour le bureau et la maison — les deux inclus." },
        { q: "Puis-je l'utiliser tous les jours ?",
          a: "Oui, conçu pour un usage quotidien. Sessions recommandées de 15-20 minutes pour un résultat optimal." },
      ],
      en: [
        { q: "What's the difference between Fabric and Velvet?",
          a: "Standard Fabric is breathable and easy to care for — perfect for daily office or car use. Premium Velvet offers a softer, more luxurious feel — ideal for the best possible experience." },
        { q: "Does it work on every seat?",
          a: "Yes — universal adjustable straps fit car seats, office chairs and sofas." },
        { q: "Is it quiet?",
          a: "Yes, a discreet motor designed for office use without disturbing anyone." },
        { q: "How does it plug in?",
          a: "Car-lighter plug for the car and a mains adapter for office and home — both included." },
        { q: "Can I use it every day?",
          a: "Yes, designed for daily use. Recommended 15–20 minute sessions for optimal results." },
      ],
    },
    images: [
      "/photos/coussin/coussin-hero.webp",
      "https://images.pexels.com/photos/6628701/pexels-photo-6628701.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1300&w=1100",
      "https://images.pexels.com/photos/6628586/pexels-photo-6628586.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1300&w=1100",
    ],
  },
  {
    id: "anneau-de-confort",
    slug: "anneau-de-confort",
    hidden: true,
    shipping_origin: "other",
    base_price: 69.0,
    currency: "EUR",
    badge: { fr: "Exclusif en France", en: "Exclusive in France" },
    name: {
      fr: "L'Anneau de Confort",
      en: "The Comfort Ring",
    },
    tagline: {
      fr: "Chaud ou froid, partout avec toi",
      en: "Hot or cold, with you everywhere",
    },
    urgency: {
      fr: "☀️ Fortes chaleurs en France — ⚡ Plus que 12 unités disponibles en Edition Blanche",
      en: "☀️ Heatwave in France — ⚡ Only 12 units left in White Edition",
    },
    certifications: {
      fr: "✅ Certifié CE (Directive EMC 2014/30/EU) — Conforme aux normes européennes de sécurité",
      en: "✅ CE certified (EMC Directive 2014/30/EU) — Compliant with European safety standards",
    },
    comparison_table: {
      fr: {
        self_label: "L'Anneau de Confort",
        other_label: "Ventilateur classique",
        rows: [
          { feature: "Vrai froid", self: "✅ jusqu'à 10°C", other: "❌ air ambiant seulement" },
          { feature: "Chaleur en hiver", self: "✅ jusqu'à 52°C", other: "❌ impossible" },
          { feature: "Batterie autonome", self: "✅ 10 heures", other: "❌ filaire uniquement" },
          { feature: "Utilisable toute l'année", self: "✅", other: "❌ range en hiver" },
          { feature: "Disponible en France", self: "✅ myFLOVEA exclusif", other: "❌ introuvable" },
        ],
      },
      en: {
        self_label: "The Comfort Ring",
        other_label: "Classic neck fan",
        rows: [
          { feature: "Real cold", self: "✅ down to 10°C", other: "❌ ambient air only" },
          { feature: "Heat in winter", self: "✅ up to 52°C", other: "❌ impossible" },
          { feature: "Built-in battery", self: "✅ 10 hours", other: "❌ wired only" },
          { feature: "All-year use", self: "✅", other: "❌ stored in winter" },
          { feature: "Available in France", self: "✅ myFLOVEA exclusive", other: "❌ unavailable" },
        ],
      },
    },
    reviews: [
      {
        name: "Karen M.",
        rating: 5,
        verified: true,
        text: {
          fr: "Incroyable — bureau sans clim, c'est devenu indispensable. Mes collègues veulent tous le même.",
          en: "Incredible — office with no AC, now it's a must. All my colleagues want one.",
        },
        image: "/photos/anneau-mixte.webp",
      },
      {
        name: "Gladys S.",
        rating: 5,
        verified: true,
        text: {
          fr: "Le froid est vraiment intense, rien à voir avec un ventilateur classique. Et en hiver je l'utilise pour me réchauffer dans ma voiture froide le matin. Vraiment toutes saisons comme promis.",
          en: "The cold is genuinely intense — nothing like a classic fan. And in winter I use it to warm up in my cold car in the morning. Truly all-season as promised.",
        },
        image: "/photos/neck-cooler-tank-top.webp",
      },
    ],
    cross_sell_slug: "coussin-massant-chauffant",
    headline: {
      fr: "La climatisation personnelle que tu portes autour du cou.",
      en: "The personal climate you wear around your neck.",
    },
    short: {
      fr: "Chaud jusqu'à 52°C ou froid jusqu'à 10°C en 3 secondes. Batterie 10h intégrée. Introuvable ailleurs en France. Livré en 8-16 jours ouvrés.",
      en: "Heat up to 52°C or cool down to 10°C in 3 seconds. Built-in 10h battery. Exclusive in France. Delivered in 8–16 business days.",
    },
    description: {
      fr: "Fortes chaleurs au bureau, chez toi ou en déplacement — pas de clim ? L'Anneau de Confort te rafraîchit en 3 secondes.\n\nMais contrairement aux ventilateurs que tu rangeras en septembre, lui reste autour de ton cou quand l'hiver arrive — prêt à te réchauffer instantanément jusqu'à 52°C. Été comme hiver, au bureau, chez toi, en voiture, en train, en déplacement — il s'adapte à toi, pas l'inverse.\n\nPorté autour du cou, léger et discret, il diffuse une fraîcheur jusqu'à 10°C ou une chaleur apaisante jusqu'à 52°C en 3 secondes chrono. 9 niveaux d'intensité pour un confort exactement à ta mesure.\n\nBatterie intégrée 10h — utilise-le toute la journée sans te brancher. Recharge via USB le soir.\n\nIntrouvable en magasin en France. Conçu pour ceux qui refusent de subir leur environnement — quelle que soit la saison.",
      en: "Heatwave at the office, at home or on the go — no AC? The Comfort Ring cools you down in 3 seconds.\n\nUnlike fans you'll pack away in September, it stays around your neck when winter comes — ready to warm you up instantly to 52°C. Summer or winter, at the office, at home, in the car, on a train, on the go — it adapts to you, not the other way around.\n\nWorn around the neck, light and discreet, it delivers a chill down to 10°C or soothing warmth up to 52°C in 3 seconds flat. 9 intensity levels for a comfort tuned exactly to you.\n\nBuilt-in 10h battery — use it all day untethered. Recharge via USB at night.\n\nNot found in stores in France. Designed for those who refuse to put up with their environment — whatever the season.",
    },
    variants: [
      {
        id: "blanc",
        price: 69.0,
        name: { fr: "Edition Blanc", en: "White Edition" },
        desc: { fr: "Design doux et discret", en: "Soft, discreet design" },
        badge: { fr: "Victime de son succès 🖤", en: "Out of stock 🖤" },
        in_stock: false,
        images: [
          "/photos/neck-cooler-tank-top.webp",
          "https://customer-assets.emergentagent.com/job_comfort-tech-shop/artifacts/u674cfgr_image.png",
        ],
      },
      {
        id: "noir",
        price: 69.0,
        name: { fr: "Edition Noir", en: "Black Edition" },
        desc: { fr: "Design tech épuré, unisex", en: "Sleek tech design, unisex" },
        badge: { fr: "Victime de son succès 🖤", en: "Out of stock 🖤" },
        in_stock: false,
        images: [
          "https://customer-assets.emergentagent.com/job_comfort-tech-shop/artifacts/u674cfgr_image.png",
          "https://customer-assets.emergentagent.com/job_comfort-tech-shop/artifacts/nw5thuwd_Noir%201.png",
          "https://customer-assets.emergentagent.com/job_comfort-tech-shop/artifacts/545ohw0j_Noir.png",
        ],
      },
    ],
    common_images: [
      "/photos/anneau-mixte.webp",
      "https://customer-assets.emergentagent.com/job_comfort-tech-shop/artifacts/zuvh7sy9_Blanc.png",
    ],
    key_points: {
      fr: [
        "⚡ Chaud ou froid en 3 secondes — 9 niveaux d'intensité pour un confort sur mesure",
        "🔋 Batterie 10h intégrée — liberté totale toute la journée sans powerbank",
        "🇫🇷 Exclusif en France — introuvable ailleurs",
      ],
      en: [
        "⚡ Hot or cold in 3 seconds — 9 intensity levels tuned exactly to you",
        "🔋 Built-in 10h battery — full day freedom, no powerbank needed",
        "🇫🇷 Exclusive in France — nowhere else",
      ],
    },
    shipping_info: {
      fr: "Expédié depuis notre entrepôt fournisseur — Livré en 8 à 16 jours ouvrés selon la destination. Numéro de suivi envoyé par email.",
      en: "Shipped from our supplier warehouse — Delivered in 8 to 16 business days depending on destination. Tracking number sent by email.",
    },
    faq: {
      fr: [
        { q: "Quelle est l'autonomie de la batterie ?",
          a: "Batterie intégrée 1000mAh — jusqu'à 10 heures d'autonomie en continu. Se recharge via USB en quelques heures." },
        { q: "Est-il discret à porter ?",
          a: "Oui, léger (230g) et fin, il se glisse sous un col de chemise ou un pull sans se voir." },
        { q: "Peut-on l'utiliser en voiture ?",
          a: "Absolument — branché sur le chargeur USB de votre voiture il fonctionne en continu pendant vos trajets, ou en autonomie batterie sans aucun câble." },
        { q: "Quelle différence avec un simple ventilateur de cou ?",
          a: "Les ventilateurs de cou soufflent de l'air ambiant. L'Anneau de Confort utilise une plaque thermoélectrique qui produit un vrai froid jusqu'à 10°C ou une vraie chaleur jusqu'à 52°C — une technologie complètement différente." },
        { q: "Pourquoi choisir le Noir plutôt que le Blanc ?",
          a: "Les deux sont identiques en fonctionnalités. Le Noir est plus discret sous les vêtements sombres, le Blanc s'associe mieux aux tenues claires et estivales — c'est uniquement une question de style." },
      ],
      en: [
        { q: "What is the battery life?",
          a: "Built-in 1000mAh battery — up to 10 hours of continuous use. Recharges via USB in a few hours." },
        { q: "Is it discreet to wear?",
          a: "Yes — light (230g) and slim, it slips under a shirt collar or sweater without showing." },
        { q: "Can I use it in the car?",
          a: "Absolutely — plug into your car's USB charger for continuous use during trips, or run on battery with no cable at all." },
        { q: "What's the difference vs. a neck fan?",
          a: "Neck fans blow ambient air. The Comfort Ring uses a thermoelectric plate that produces real cold down to 10°C or real heat up to 52°C — a completely different technology." },
        { q: "Why pick Black over White?",
          a: "Both are identical in features. Black is more discreet under darker outfits, White pairs better with light, summer outfits — it's purely a style choice." },
      ],
    },
    images: [
      "/photos/neck-cooler-tank-top.webp",
      "https://images.pexels.com/photos/6629554/pexels-photo-6629554.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1300&w=1100",
      "https://images.pexels.com/photos/6628809/pexels-photo-6628809.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1300&w=1100",
    ],
  },
  {
    id: "sphere-duo",
    slug: "sphere-duo",
    shipping_origin: "other",
    base_price: 23.90,
    name: { fr: "La Sphère Duo — Massage Froid & Chaud", en: "The Duo Sphere — Cold & Hot Massage" },
    tagline: {
      fr: "Fraîcheur immédiate, chaleur apaisante — à toi de choisir.",
      en: "Instant coolness, soothing warmth — you choose.",
    },
    short: {
      fr: "Sphère en acier inoxydable 2-en-1 : froid instantané ou chaleur apaisante. Format nomade — Livré en 8-14 jours ouvrés.",
      en: "Stainless-steel 2-in-1 sphere: instant cold or soothing warmth. Pocket-friendly — Delivered in 8–14 business days.",
    },
    variants: [
      {
        id: "default",
        price: 23.90,
        compare_at_price: 27.90,
        name: { fr: "La Sphère Duo", en: "The Duo Sphere" },
        badge: { fr: "-14% Lancement", en: "-14% Launch" },
        in_stock: true,
        images: [
          "/photos/sphere-duo-hero.webp",
        ],
      },
    ],
    common_images: [
      "/photos/sphere-duo-box.webp",
      "/photos/sphere-duo-open.webp",
      "/photos/sphere-duo-dimensions.webp",
      "/photos/sphere-duo-relief.webp",
    ],
    shipping_info: {
      fr: "Livraison estimée : 8 à 14 jours ouvrés.",
      en: "Estimated delivery: 8 to 14 business days.",
    },
    cross_sell_slugs: ["coussin-massant-chauffant"],
    images: [
      "/photos/sphere-duo-card.webp",
    ],
  },
  {
    id: "tapis-serenite",
    slug: "tapis-serenite",
    hidden: true,
    shipping_origin: "other",
    base_price: 32.90,
    name: { fr: "Le Tapis Sérénité — Duo Acupression", en: "The Serenity Mat — Acupressure Duo" },
    tagline: {
      fr: "20 minutes allongée, et les tensions s'effacent.",
      en: "20 minutes lying down, and tension melts away.",
    },
    short: {
      fr: "Tapis d'acupression inspiré des pratiques ancestrales. Livré en 8-14 jours.",
      en: "Acupressure mat inspired by ancestral practices. Delivered in 8–14 days.",
    },
    variants: [
      {
        id: "tapis-seul",
        price: 21.90,
        compare_at_price: 24.90,
        name: { fr: "Tapis seul", en: "Mat only" },
        badge: { fr: "-12% Lancement", en: "-12% Launch" },
        in_stock: true,
      },
      {
        id: "ensemble-complet",
        price: 32.90,
        compare_at_price: 37.90,
        name: { fr: "Ensemble complet", en: "Complete set" },
        badge: { fr: "✨ Le plus complet · -13%", en: "✨ Most complete · -13%" },
        in_stock: true,
        default: true,
      },
    ],
    shipping_info: {
      fr: "Livraison estimée : 8 à 14 jours ouvrés.",
      en: "Estimated delivery: 8 to 14 business days.",
    },
    cross_sell_slugs: ["sphere-duo", "coussin-massant-chauffant"],
    images: [
      "https://images.pexels.com/photos/6111570/pexels-photo-6111570.jpeg?auto=compress&cs=tinysrgb&h=1300&w=1100",
    ],
  },
];

export const STATIC_PRODUCTS = RAW_STATIC_PRODUCTS.filter((p) => !p.hidden);

export const findStaticProduct = (slug) =>
  STATIC_PRODUCTS.find((p) => p.slug === slug || p.id === slug) || null;
